import { createFileRoute } from "@tanstack/react-router";
import Title from "../../../components/common/Title";
import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from "../../../components/ui/card";

const PatientHelpPage = () => {
	return (
		<section className="lg-width">
			<Title words="Help for Patients" />

			{/* Video Tutorial */}
			<div className="relative mx-4 p-8 pb-[56.25%] max-w-lg">
				<iframe
					title="Patient Watch Explainer for Patients"
					src="https://www.loom.com/embed/43564392bdea41e59930e0d7b59510b3?sid=4c20adbe-561c-45c8-b568-1c33870ce1ed"
					allowFullScreen
					className="top-0 left-0 absolute w-full h-full"
				/>
			</div>

			<div className="space-y-8 px-4 py-8">
				{/* Getting Started */}
				<Card>
					<CardHeader>
						<CardTitle>Getting Started</CardTitle>
					</CardHeader>
					<CardContent className="space-y-4">
						<h3 className="font-semibold">Quick Start:</h3>
						<ol className="space-y-2 list-decimal list-inside">
							<li>
								Scan the QR code from your doctor, or click "Yes" on the invite
								email
							</li>
							<li>Enter your email and create a password</li>
							<li>Add your phone number for SMS reminders</li>
						</ol>
					</CardContent>
				</Card>

				{/* Recording Your Pain */}
				<Card>
					<CardHeader>
						<CardTitle>Recording Your Pain</CardTitle>
					</CardHeader>
					<CardContent className="space-y-4">
						<h3 className="font-semibold">When to Record:</h3>
						<ul className="space-y-2 list-disc list-inside">
							<li>Weekly before your injection</li>
							<li>Pre-injection</li>
							<li>Immediately after injection</li>
							<li>6 hours after injection</li>
							<li>Day 1 after injection</li>
							<li>Weekly after Day 1</li>
						</ul>

						<div className="bg-muted mt-4 p-4 rounded-lg">
							<p className="font-semibold">Important:</p>
							<ul className="space-y-2 mt-2 list-disc list-inside">
								<li>You'll get SMS and email reminders</li>
								<li>
									Your clinician will review your diary and contact you if
									required
								</li>
							</ul>
						</div>
					</CardContent>
				</Card>

				{/* Getting Help */}
				<Card>
					<CardHeader>
						<CardTitle>Need Help?</CardTitle>
					</CardHeader>
					<CardContent>
						<ul className="space-y-2 list-disc list-inside">
							<li>Return to this help section</li>
							<li>Contact your healthcare provider</li>
						</ul>
					</CardContent>
				</Card>
			</div>
		</section>
	);
};

export const Route = createFileRoute("/_app/help/patient")({
	component: PatientHelpPage,
});
